import { APITransport } from '@client/transports/api';

export const AssetsService = {
  async getByHash(rulename, type) {
    let response = [];

    if (type === 'documents') {
      response = await this.getAllDocuments();
    }

    if (type === 'images') {
      response = await this.getAllImages();
    }

    if (type === 'videos') {
      response = await this.getAllVideos();
    }

    return response.find((item) => item.rulename === rulename);
  },
  async getAllDocuments() {
    const response = await APITransport.get({
      path: '/rest/domain/documents'
    });

    return Array.isArray(response) ? response : [];
  },
  async getAllImages() {
    const response = await APITransport.get({
      path: '/rest/domain/images'
    });

    return Array.isArray(response) ? response : [];
  },
  async getAllVideos() {
    const response = await APITransport.get({
      path: '/rest/domain/videos'
    });

    return Array.isArray(response) ? response : [];
  },
  async getAssetFolders() {
    const response = await APITransport.get({
      path: '/rest/assetfolders/'
    });

    return Array.isArray(response) ? response : [];
  },
  async getDocumentMetrics(docid, hash, days = 1000) {
    return APITransport.get({
      path: '/rest/domain/report/attachmentdata',
      query: {
        days,
        docid,
        hash
      }
    });
  },
  async getVideoMetrics(objid, vidid) {
    return APITransport.get({
      path: '/rest/domain/report/videodata2',
      query: {
        objid,
        vidid
      }
    });
  },
  async addDocument(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/documents',
      body
    });
  },
  async addImage(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/images',
      body
    });
  },
  async addVideo(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/videos',
      body
    });
  },
  async uploadFile(name, type, body = {}) {
    return APITransport.post({
      path: '/rest/server/upload/file',
      headers: {
        'X-File-Name': encodeURIComponent(name),
        'X-File-Mimetype': type
      },
      body
    });
  },
  async bulkUploadFiles(body = {}) {
    return APITransport.post({
      path: 'rest/server/upload/bulkfile',
      body
    });
  },
  async updateDocument(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/documents',
      body
    });
  },
  async updateImage(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/images',
      body
    });
  },
  async updateVideo(body = {}) {
    return APITransport.post({
      path: '/rest/domain/save/videos',
      body
    });
  },
  async deleteDocument(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/documents',
      body
    });
  },
  async deleteImage(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/images',
      body
    });
  },
  async deleteVideo(body = {}) {
    return APITransport.post({
      path: '/rest/domain/delete/videos',
      body
    });
  }
};
